module.exports = __webpack_public_path__ + "img/product-placeholder-77.a9abef9.png";